// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32cuE","questions":"styles_questions__FK1T1","footer":"styles_footer__2OkRW"};